/* cvn-size-guard.js — lifted verbatim out of snippets/cvn-size-guard.liquid on 2026-09-25 (theme audit v77).
   It used to be an inline <script> re-sent with every page; as an asset it is minified by the CDN and cached.
   Execution point is unchanged: the snippet loads it (blocking, no defer) exactly where the block was. */
    if (!customElements.get('cvn-size-guard')) {
      customElements.define('cvn-size-guard', class extends HTMLElement {
        /* ⚠ AN ALREADY-DEFINED CUSTOM ELEMENT UPGRADES ON ITS START TAG, BEFORE
           ITS CHILDREN EXIST — and that is why this failed on a SOFT navigation
           only. On a hard load the definition below runs AFTER this markup has
           parsed, so every instance upgrades with its children already in place
           and `querySelector` finds the checkbox. Arrive at /cart through the
           theme's in-place nav (or let any cart re-render replace
           `.js-contents`) and the element is already defined, so it upgrades
           the moment `innerHTML` inserts the opening tag: the checkbox is not
           there yet, the old code returned early, and the guard never
           initialised again.
           ⚠ THE SYMPTOM POINTED AWAY FROM THE CAUSE. The drawer's own guard —
           in the LAYOUT, never re-parsed — still ran, and its `apply()` locks
           `#CartDrawer-Checkout, #checkout` with a DOCUMENT-WIDE query. So the
           page's Checkout button was correctly greyed out by a guard the
           shopper could not see, while the page's own guard sat there with its
           `hidden` attribute untouched. Locked-with-no-checkbox reads as a
           render or caching fault; it was neither.
           So: never assume children in connectedCallback. Retry across frames
           until they arrive, bounded so an element that genuinely has no
           checkbox cannot spin forever. */
        connectedCallback() {
          if (this.__cvnInit) return;
          var self = this;
          var tries = 0;
          var boot = function () {
            if (self.__cvnInit || !self.isConnected) return;
            if (!self.querySelector('.cvn-size-guard__box')) {
              /* ⚠ THE BOXLESS GLOBAL INSTANCE — the one element that is SUPPOSED
                 to have no checkbox. It exists so the one-time block in
                 __cvnBoot() runs on an EMPTY cart, where no real guard is
                 rendered (a guard belongs to a cart LINE). It boots on
                 DOMContentLoaded, not here: this callback fires on the start
                 tag during parse, and the block attaches observers to
                 <cart-drawer> and #main-cart-items, which may not exist yet.
                 A real guard is unaffected — it still boots at parse time and
                 claims the flag first, so this one finds the work already done
                 and stops at the box check. */
              if (self.hasAttribute('data-cvn-global')) {
                var go = function () {
                  if (self.__cvnInit) return;
                  self.__cvnInit = true;
                  self.__cvnBoot();
                };
                if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
                else go();
                return;
              }
              if (++tries > 60) return;
              requestAnimationFrame(boot);
              return;
            }
            self.__cvnInit = true;
            self.__cvnBoot();
          };
          boot();
        }
        __cvnBoot() {
          /* ⚠ THE ONE-TIME BLOCK RUNS FIRST, AHEAD OF THE BOX CHECK — and the
             order is the whole point, not tidiness.
             Everything the recommendation rails depend on lives in it: the
             quick-view modal PARKING (moving the dialog out of the transformed
             drawer panel and onto <body>), the house price formatter, the size
             labels, the drawer-open hook. It used to sit AFTER
             `if (!box) return;`, which made all of it conditional on a cart
             LINE existing — because a <cvn-size-guard> element is rendered per
             line and nowhere else.
             So an EMPTY cart booted NONE of it, on either surface. The drawer's
             Best-sellers rail rendered, its Quick view buttons rendered, its
             dialog rendered, the id resolved, Dawn's show() ran and the content
             fetch landed — and nothing ever moved the dialog out of the panel,
             so it opened as a 499px box pinned to the panel's edge. Every
             signal but one looked healthy; the only tell was `modalsOnBody: 0`.
             ⚠ The snippet comment above already says the SCRIPT must be
             unconditional, and it is. That was necessary and not sufficient:
             the script only DEFINES the element. The block still needed an
             INSTANCE, and line 31 emits none on an empty cart.
             Hoisting costs nothing when the cart has lines — the flag makes it
             run exactly once either way — and lets the boxless `data-cvn-global`
             instance boot it when the cart has none. */
          if (!window.cvnSizeGuardIntercept) {
            window.cvnSizeGuardIntercept = true;

            // ---- per-line size states (measured shoppers) ----
            // Reads cvn_sf_recs (written by the size finder, keys are the
            // blank_info handles: blank-<catalog_id>) and decorates each
            // apparel line: recommended tag, also-fits tag, or the mismatch
            // row with change / keep / gift pills.
            // Keeps each line's visual position stable: a size swap re-adds the
            // variant and Shopify moves it to the top, so the session's row
            // order is pinned and the new key takes the old key's slot.
            // Ordered by VARIANT id, not the full line key: Shopify regenerates
            // the key's hash suffix on every cart mutation, so full keys go
            // stale the moment anything changes. Variant ids are stable, and a
            // swap declares its from/to ids so the new line takes the old slot.
            // ⚠ TWO CONTAINERS, ONE ORDER. The /cart page renders its own
            // stamped rows (#main-cart-items) beside the drawer's, and both
            // must keep the same pinned order — so the expected order is
            // computed ONCE (the pending swap is consumed once, never by the
            // first container at the second's expense) and applied per
            // container. A drawer-scoped version left the page's rows
            // jumping to the top on every size swap.
            var applyCartOrder = function () {
              var vidOf = function (tr) { return (tr.getAttribute('data-cvn-line-key') || '').split(':')[0]; };
              var rowSets = [];
              [document.querySelector('cart-drawer'), document.getElementById('main-cart-items')].forEach(function (root) {
                if (!root) return;
                var rows = Array.prototype.slice.call(root.querySelectorAll('tr[data-cvn-line-key]'));
                if (rows.length) rowSets.push(rows);
              });
              if (!rowSets.length) return;
              var cur = rowSets[0].map(vidOf);
              var stored = [];
              try { stored = JSON.parse(sessionStorage.getItem('cvn_cart_order') || '[]'); } catch (e) {}
              var p = window.cvnPendingSwap;
              if (p && cur.indexOf(p.from) === -1) {
                var idx = stored.indexOf(p.from);
                if (idx !== -1) {
                  if (stored.indexOf(p.to) !== -1) stored.splice(idx, 1);
                  else stored.splice(idx, 1, p.to);
                }
                window.cvnPendingSwap = null;
              }
              var expected = stored.filter(function (k) { return cur.indexOf(k) !== -1; });
              var newOnes = cur.filter(function (k) { return expected.indexOf(k) === -1; });
              expected = newOnes.concat(expected);
              try { sessionStorage.setItem('cvn_cart_order', JSON.stringify(expected)); } catch (e) {}
              rowSets.forEach(function (rows) {
                var rcur = rows.map(vidOf);
                if (expected.join('|') === rcur.join('|')) return;
                var tbody = rows[0].parentNode;
                var byVid = {};
                rows.forEach(function (tr) { byVid[vidOf(tr)] = tr; });
                expected.forEach(function (k) { if (byVid[k]) tbody.appendChild(byVid[k]); });
              });
            };

            // Recommendations rail boot: the strip inside [data-cvn-rail]
            // arrives with each cart re-render, and scripts injected via
            // innerHTML never execute - re-create any unbooted one. The
            // strip's own data-pop-ready guard makes a re-run a no-op, so
            // this is idempotent (the first, natively-executed run included).
            // ⚠ /cart HOLDS TWO RAILS — the drawer's (first in document
            // order) and the page's. A singular query prepared only the
            // drawer's, so the page's strip never got its type round-robin
            // mix and its top read as one artwork three times. Every
            // per-rail step below is guarded and idempotent, so iterating is
            // safe; the modal-parking block only ever finds modals in the
            // drawer's rail, because the page deliberately emits none.
            var railBoot = function () {
              if (window.__cvnRailBootOff) return;
              var cvnAllRails = document.querySelectorAll('[data-cvn-rail]');
              // ⚠ NO EARLY RETURN HERE ANY MORE — it now guards only the card
              // poke at the foot. A collection page can legitimately carry NO
              // rail (empty cart + empty best-sellers pool) and still carry
              // `#QuickAddCvn`, which the per-modal half below has to wire.
              // forEach over an empty NodeList is a no-op, so rail work is
              // unchanged.
              cvnAllRails.forEach(function (rail) {
              // type round-robin, preferring a DIFFERENT design than the
              // previous card: the pool arrives tiered (all tees first) and
              // every type queue leads with the same design family, so
              // without this the top of the rail is one artwork three times
              var scroll = rail.querySelector('[data-cvn-rail-scroll]');
              if (scroll && !scroll.__cvnMixed) {
                scroll.__cvnMixed = true;
                var cardsArr = Array.prototype.slice.call(scroll.querySelectorAll('.card-wrapper[data-ptype]'));
                var groups = {}, order = [];
                cardsArr.forEach(function (c) {
                  var ty = c.getAttribute('data-ptype') || '';
                  if (!groups[ty]) { groups[ty] = []; order.push(ty); }
                  groups[ty].push(c);
                });
                if (order.length > 1) {
                  var dOf = function (c) { return c.getAttribute('data-dkey') || ''; };
                  var out = [], lastD = null;
                  while (out.length < cardsArr.length) {
                    var took = false;
                    for (var i = 0; i < order.length && out.length < cardsArr.length; i++) {
                      var q = groups[order[i]];
                      if (!q.length) continue;
                      var pickIdx = 0;
                      for (var k = 0; k < q.length; k++) {
                        if (dOf(q[k]) !== lastD) { pickIdx = k; break; }
                      }
                      var c = q.splice(pickIdx, 1)[0];
                      out.push(c);
                      lastD = dOf(c);
                      took = true;
                    }
                    if (!took) break;
                  }
                  out.forEach(function (c) { scroll.appendChild(c); });
                }
              }
              });
              // ⚠ THE RAIL LOOP ENDS ABOVE. Everything below is PER MODAL, not
              // per rail, and runs ONCE per railBoot over the WHOLE document —
              // because `#QuickAddCvn` (cvn-qv.liquid, the collection-card quick
              // view) is parked on <body> by Dawn's own ModalDialog and is owned
              // by NO rail. While this block was nested in the loop and scoped
              // `rail.querySelectorAll(...)`, that dialog got none of the
              // enhancements below — no zoom, no buy bar, no "View Full Details
              // of this T-Shirt", no height fixes.
              // ⚠ DO NOT instead put `data-cvn-rail` on its host: the loop above
              // then treats it as a real rail and the parking step below moves
              // the dialog out of it, leaving the host at innerHTML.length 0.
              // the quick-add modals must NOT live inside the drawer: the
              // sliding panel is a transformed ancestor, which makes it the
              // containing block for position:fixed and traps the dialog.
              // Park them on <body>, replacing the previous render's set.
              // ⚠ THE STALE PARKED DIALOG IS DROPPED BEFORE `fresh` IS READ, and
              // ONLY when a rail has re-rendered a copy carrying the SAME id. The
              // unscoped `remove()` this replaces also deleted `#QuickAddCvn` —
              // on every cart re-render, and on DOMContentLoaded whenever no
              // apparel guard rendered — so every collection Quick view became a
              // button that clicks cleanly and does nothing, with no error
              // anywhere and the dialog simply absent from the document.
              document.querySelectorAll('body > quick-add-modal.cvn-rail-modal').forEach(function (m) {
                if (m.id && document.querySelector('[data-cvn-rail] quick-add-modal#' + m.id)) m.remove();
              });
              var fresh = document.querySelectorAll('quick-add-modal.cvn-rail-modal');
              if (fresh.length) {
                // house price format (superscript cents) for content fetched
                // into the dialog: the PDP's own formatter is closure-scoped
                // to page load and never sees it. Same regex + spans.
                var cvnFmtPrice = function (el) {
                  if (el.querySelector('.cvn-int')) { el.classList.add('cvn-fmt'); return; }
                  var txt = (el.textContent || '').trim();
                  var pm = txt.match(/^(\D*)(.+)[.,](\d{2})(\D*)$/);
                  if (pm) {
                    el.innerHTML = '<span class="cvn-cur">' + pm[1] + '</span><span class="cvn-int">' + pm[2] + '</span><span class="cvn-cents">' + pm[3] + '</span>' + (pm[4] ? '<span class="cvn-cur">' + pm[4] + '</span>' : '');
                  }
                  el.classList.add('cvn-fmt');
                };
                // media sizing must be INLINE: the theme's media CSS lives in
                // a cascade layer, and layered !important outranks EVERY
                // unlayered stylesheet !important - only the style attribute
                // wins. Contained, never cropped. 33rem is the photo knob.
                var cvnQvSize = function (m) {
                  // PHONE GETS A SMALLER PHOTO (Zeus): on a phone this dialog is
                  // a full-height sheet and the photo was taking the room the
                  // title, price and size rows need. 254px is 330 stepped down by
                  // 10%, 10% and 5%; desktop's side panel is unchanged.
                  // ⚠ Read on EVERY call, not
                  // cached - the dialog can be opened after a rotate or a resize,
                  // and the guard below rewrites the value whenever it differs,
                  // so the photo re-sizes itself rather than keeping whichever
                  // width the page happened to load at.
                  // ⚠ THIS IS THE ONE PLACE THE QUICK-VIEW PHOTO IS SIZED — container
                  // and image together, so no white can open up between them. The
                  // phone SHEET (`.cvn-qv-sheet`, defined in cvn-qv.liquid; carried
                  // by the collection-card dialog AND the cart drawer / cart page
                  // dialog) runs at 205px because it is partial-height and has to
                  // fit without scrolling. Change the number HERE, never in a
                  // stylesheet: the values below are written inline with
                  // !important, so a CSS override can only lose, and a second JS
                  // writer fighting this one made the photo blink.
                  var isPhone = window.matchMedia && window.matchMedia('(max-width: 989.98px)').matches;
                  var isSheet = m.classList.contains('cvn-qv-sheet');
                  var want = isPhone ? (isSheet ? '205px' : '254px') : '330px';
                  m.querySelectorAll('.product-media-container').forEach(function (c) {
                    if (c.style.getPropertyValue('height') !== want) {
                      c.style.setProperty('height', want, 'important');
                      c.style.setProperty('max-height', want, 'important');
                      c.style.setProperty('padding', '0', 'important');
                    }
                  });
                  m.querySelectorAll('.product-media-container img').forEach(function (i) {
                    if (i.style.getPropertyValue('height') !== want) {
                      i.style.setProperty('height', want, 'important');
                      i.style.setProperty('object-fit', 'contain', 'important');
                      i.style.setProperty('object-position', 'center', 'important');
                    }
                  });
                  // quick-add.css gives product-info and content-info 100%
                  // heights plus section padding - together an ~80px tail under
                  // View full details, which is all the dialog's scrollbar was.
                  // height:auto on both + padding 0 = the dialog hugs content.
                  // no anchor inside the media zone may navigate - the theme's
                  // client-side nav captures anchor clicks before any handler
                  m.querySelectorAll('.product__media-wrapper a[href]').forEach(function (za) {
                    za.removeAttribute('href');
                  });
                  // ⚠️ SINGLE-INSTANCE finder rule: the dialog's fetched copy of
                  // the finder overlay is structurally unreliable (cvn-sf-marks
                  // binds ONE instance at page load, so a late copy renders its
                  // screens at opacity 0 - the "blank window"). Strip it; the
                  // pill stays and opens the page's finder or a fresh mount via
                  // the verified fallback.
                  m.querySelectorAll('.cvn-sf__overlay').forEach(function (deadOv) { deadOv.remove(); });
                  // the dialog's finder pill label: its own applyProfile is gone
                  // with the stripped instance, so the guard paints it from the
                  // recs cache (same source as the drawer's line decorations)
                  var sfLbl = m.querySelector('[data-cvn-sf-pill-label]');
                  if (sfLbl) {
                    var qvCid = { 'T-Shirt': 71, 'Sweatshirt': 145, 'Hoodie': 294 }[m.dataset.cvnPtype || ''];
                    var qvRec = null;
                    try {
                      var qvRecs = JSON.parse(localStorage.getItem('cvn_sf_recs') || 'null');
                      qvRec = qvRecs && qvCid ? qvRecs['blank-' + qvCid] : null;
                    } catch (e) {}
                    if (qvRec && qvRec.pick) {
                      var wantLbl = 'Recommended size: <span class="cvn-sf__rec">' + qvRec.pick + '</span>' + (qvRec.alt ? ' <span class="cvn-sf__dim">(' + qvRec.alt + ' also fits)</span>' : '');
                      if (sfLbl.__cvnQvLbl !== wantLbl) {
                        sfLbl.innerHTML = wantLbl;
                        sfLbl.__cvnQvLbl = wantLbl;
                        var sfChev = m.querySelector('[data-cvn-sf-pill-chev]');
                        if (sfChev) sfChev.hidden = false;
                      }
                    }
                  }
                  var pi = m.querySelector('product-info');
                  if (pi && pi.style.getPropertyValue('height') !== 'auto') {
                    pi.style.setProperty('padding-top', '0', 'important');
                    pi.style.setProperty('padding-bottom', '0', 'important');
                    pi.style.setProperty('height', 'auto', 'important');
                  }
                  var ci = m.querySelector('.quick-add-modal__content-info');
                  if (ci && ci.style.getPropertyValue('height') !== 'auto') {
                    ci.style.setProperty('padding-bottom', '0.6rem', 'important');
                    ci.style.setProperty('height', 'auto', 'important');
                  }
                  // buy bar: quantity + Add on one line, pinned to the panel
                  // bottom (CSS margin-top:auto). Built once per content load;
                  // a variant swap replaces variant-selects only, so the bar
                  // and the nodes moved into it survive.
                  // the footer bar lives OUTSIDE the scroll area (a sibling
                  // of content-info), so Add to cart + View Full Details stay
                  // visible however far the middle scrolls - like the drawer's
                  // checkout footer. A form still sitting INSIDE the scroll
                  // area is the sign of freshly fetched content: (re)seat it,
                  // clearing the previous product's form from the bar.
                  var qcontent = m.querySelector('.quick-add-modal__content');
                  var qinfoC = m.querySelector('.product__info-container');
                  var freshForm = qinfoC && qinfoC.querySelector('product-form');
                  if (qcontent && freshForm) {
                    var bb = m.querySelector('.cvn-qv-buybar');
                    if (!bb) {
                      bb = document.createElement('div');
                      bb.className = 'cvn-qv-buybar';
                      qcontent.appendChild(bb);
                    }
                    while (bb.firstChild) bb.removeChild(bb.firstChild);
                    bb.appendChild(freshForm);
                    // quantity ships INSIDE Dawn's product-form; it belongs in
                    // the scroll area, last before the footer line (order 19)
                    var qq = bb.querySelector('.product-form__quantity');
                    if (qq) qinfoC.appendChild(qq);
                    var vdlnk = qinfoC.querySelector('.product__view-details');
                    if (vdlnk) bb.appendChild(vdlnk);
                  }
                  // ⚠️ variant sync: the form lives in the footer bar, OUTSIDE
                  // <product-info>, so Dawn's own variant-change handler
                  // (product-info.querySelector('product-form')) never updates
                  // its id input - Add to cart submitted the FETCH-DEFAULT
                  // variant whatever was picked. The picker swap rewrites the
                  // [data-selected-variant] JSON inside variant-selects; mirror
                  // its id into the bar form on every pass (guarded write).
                  var selJson = m.querySelector('variant-selects [data-selected-variant]');
                  var idInput = m.querySelector('.cvn-qv-buybar form input[name="id"]');
                  if (selJson && idInput) {
                    try {
                      var selVar = JSON.parse(selJson.textContent);
                      if (selVar && selVar.id && String(idInput.value) !== String(selVar.id)) {
                        idInput.value = selVar.id;
                        idInput.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    } catch (e) {}
                  }
                  // view-details label names the blank: "View Full Details of
                  // this T-Shirt". The type is stashed on the modal by the
                  // rail card's Quick view click (data-ptype); only the TEXT
                  // node changes, so the arrow icon survives.
                  var vdl = m.querySelector('.product__view-details');
                  if (vdl) {
                    var pt = m.dataset.cvnPtype || '';
                    var want = pt ? 'View Full Details of this ' + pt : 'View Full Details';
                    if (vdl.dataset.cvnVd !== want) {
                      vdl.dataset.cvnVd = want;
                      var tn = null;
                      for (var q = 0; q < vdl.childNodes.length; q++) {
                        var nn = vdl.childNodes[q];
                        if (nn.nodeType === 3 && nn.nodeValue.replace(/\s/g, '')) { tn = nn; break; }
                      }
                      if (tn) tn.nodeValue = want + ' ';
                      else vdl.insertBefore(document.createTextNode(want + ' '), vdl.firstChild);
                    }
                  }
                };
                fresh.forEach(function (m) {
                  // ⚠ ONCE PER ELEMENT. This block is NOT idempotent: it adds two
                  // MutationObservers and a capture-phase click listener, all
                  // anonymous, so a second pass doubles them — the zoom toggle
                  // then fires twice (on, then straight off) and reads as dead.
                  // It used to be safe by accident: a rail modal was findable
                  // only while still inside its rail, and the append below took
                  // it out of range for good. Now the query is document-wide, so
                  // this flag is the whole guarantee. A re-rendered rail emits a
                  // BRAND NEW element, which correctly has no flag.
                  if (m.__cvnQvWired) return;
                  m.__cvnQvWired = true;
                  m.style.zIndex = '1200'; // above the drawer's 1000
                  document.body.appendChild(m);
                  new MutationObserver(function () {
                    m.querySelectorAll('.price .price-item--regular:not(.cvn-fmt)').forEach(cvnFmtPrice);
                    cvnQvSize(m); // inline writes are attribute mutations - invisible to this childList observer, no loop
                  }).observe(m, { childList: true, subtree: true });
                  cvnQvSize(m);
                  // Dawn's modal hide() drops the body scroll lock the OPEN
                  // drawer still needs - closing the quick view made the page
                  // behind scrollable. Re-arm it while the drawer is active.
                  new MutationObserver(function () {
                    if (!m.hasAttribute('open')) {
                      var dlk = document.querySelector('cart-drawer');
                      if (dlk && dlk.classList.contains('active')) document.body.classList.add('overflow-hidden');
                    }
                  }).observe(m, { attributes: true, attributeFilter: ['open'] });
                  // photo click = ZOOM at the click point, never Dawn's media
                  // lightbox and never a navigation. Capture phase on the
                  // dialog beats the modal-opener button's own handler.
                  m.addEventListener('click', function (e) {
                    if (!e.target.closest) return;
                    var mw = e.target.closest('.product__media-wrapper');
                    if (!mw) return;
                    // the photo-nav chevrons and thumbnails keep their jobs -
                    // only clicks on the PICTURE itself zoom; changing photo
                    // resets any zoom so the next photo starts clean
                    if (e.target.closest('.slider-button, .thumbnail, .cvn-cc-arrow')) {
                      mw.querySelectorAll('.cvn-qv-zoomed').forEach(function (z) {
                        z.classList.remove('cvn-qv-zoomed');
                        z.style.removeProperty('transform-origin');
                      });
                      return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    // zoom the CLICKED photo (photo 2+ after the chevrons),
                    // never blindly the first img in the wrapper
                    var zi = e.target.closest('img');
                    if (!zi) {
                      zi = [].find.call(mw.querySelectorAll('.product-media-container img'), function (im) {
                        var zr = im.getBoundingClientRect();
                        return zr.width > 50 && zr.height > 50;
                      }) || mw.querySelector('img');
                    }
                    if (!zi) return;
                    var zr = zi.getBoundingClientRect();
                    if (zi.classList.contains('cvn-qv-zoomed')) {
                      zi.classList.remove('cvn-qv-zoomed');
                      zi.style.removeProperty('transform-origin');
                    } else {
                      var zx = ((e.clientX - zr.left) / zr.width * 100).toFixed(1);
                      var zy = ((e.clientY - zr.top) / zr.height * 100).toFixed(1);
                      zi.style.setProperty('transform-origin', zx + '% ' + zy + '%');
                      zi.classList.add('cvn-qv-zoomed');
                    }
                  }, true);
                });
              }
              if (!cvnAllRails.length) return;
              // cvn-card-colors.js builds cards via its own body observer,
              // which never fires on a plain drawer OPEN (a class change) -
              // poke one childList mutation so its debounced run() looks now
              var poke = document.createComment('cvn-rail-poke');
              document.body.appendChild(poke);
              poke.remove();
            };

            var decorateLines = function () {
              applyCartOrder();
              railBoot();
              // top-of-cart size entry: label follows the profile state
              var hasProfile = false;
              try { hasProfile = !!localStorage.getItem('cvn_fit_profile'); } catch (e) {}
              // write-only-on-change: an unconditional write here feeds the
              // mutation observer its own output and loops the decorator
              document.querySelectorAll('[data-cvn-sf-entry]').forEach(function (b) {
                // write the LABEL SPAN only - the tape icon beside it survives
                var lbl = b.querySelector('[data-cvn-sf-entry-label]') || b;
                var want = hasProfile ? 'My size profile' : 'What’s my size?';
                if (lbl.textContent !== want) lbl.textContent = want;
              });
              var recs = null;
              try { recs = JSON.parse(localStorage.getItem('cvn_sf_recs') || 'null'); } catch (e) {}
              document.querySelectorAll('[data-cvn-cid]').forEach(function (row) {
                var slot = row.querySelector('[data-cvn-line-slot]');
                if (!slot) return;
                // Size comment sits inline after "Size: X | ..." (PDP pattern);
                // the slot below keeps only what can't fit inline (pills, gift note).
                var opt = row.querySelector('[data-cvn-size-opt]');
                var setInline = function (html) {
                  if (!opt) return false;
                  if (opt.__cvnInline === html) return true;
                  var old = opt.querySelector('.cvn-line-inline');
                  if (old) old.remove();
                  if (html) opt.insertAdjacentHTML('beforeend', '<span class="cvn-line-inline"><span class="cvn-line-sep" aria-hidden="true">|</span>' + html + '</span>');
                  opt.__cvnInline = html;
                  return true;
                };
                var setSlot = function (html) {
                  if (slot.__cvnHtml !== html) {
                    slot.innerHTML = html;
                    slot.__cvnHtml = html;
                  }
                  slot.hidden = html === '';
                };
                var rec = recs && recs['blank-' + row.getAttribute('data-cvn-cid')];
                if (!rec || !rec.pick) { setInline(''); setSlot(''); return; }
                var size = row.getAttribute('data-cvn-line-size');
                var key = row.getAttribute('data-cvn-line-key');
                // one persistent choice per line: keep (default) or gift;
                // "change size" is an action, not a state
                var sel = 'keep';
                try { sel = sessionStorage.getItem('cvn_sel_' + key) || 'keep'; } catch (e) {}
                var vmap = {};
                var vmapEl = row.querySelector('[data-cvn-line-variants]');
                try { vmap = JSON.parse(vmapEl ? vmapEl.textContent : '{}'); } catch (e) {}
                var qty = row.getAttribute('data-cvn-line-qty') || '1';
                if (size === rec.pick) {
                  var good = '<span class="cvn-line-tag cvn-line-tag--good">&#10003; Your recommended size</span>';
                  if (setInline(good)) setSlot('');
                  else setSlot(good);
                  return;
                }
                if (size === rec.alt) {
                  var alt = '<span class="cvn-line-tag cvn-line-tag--alt">&bull; Also fits you</span>';
                  var pv = vmap[rec.pick];
                  var altPill = (pv && pv.a)
                    ? '<button type="button" class="cvn-line-seg__btn cvn-line-seg__btn--change cvn-line-swap-one" data-cvn-swap="' + pv.id + '" data-cvn-swap-key="' + key + '" data-cvn-swap-qty="' + qty + '">Change size to recommended: ' + rec.pick + '</button>'
                    : '';
                  var altInlined = setInline(alt);
                  setSlot((altInlined ? '' : alt) + altPill);
                  return;
                }
                // dropdown order: recommended, also-fits, then the ladder
                var order = [rec.pick];
                if (rec.alt) order.push(rec.alt);
                Object.keys(vmap).forEach(function (s) {
                  if (s !== rec.pick && s !== rec.alt && s !== size) order.push(s);
                });
                var items = order.map(function (s) {
                  var v = vmap[s];
                  if (!v) return '';
                  var label = '<span class="cvn-dd-size">' + s + '</span>';
                  if (s === rec.pick) label += '<span class="cvn-dd-good"><span class="cvn-dd-mark">&#10003;</span>Recommended</span>';
                  else if (s === rec.alt) label += '<span class="cvn-dd-alt"><span class="cvn-dd-mark">&bull;</span>Also fits</span>';
                  if (!v.a) return '<div class="cvn-dd-item cvn-dd-item--off">' + label + ' &middot; sold out</div>';
                  return '<button type="button" class="cvn-dd-item" data-cvn-swap="' + v.id + '" data-cvn-swap-key="' + key + '" data-cvn-swap-qty="' + qty + '">' + label + '</button>';
                }).join('');
                var seg = '<div class="cvn-line-seg">'
                  + '<span class="cvn-line-dd">'
                  + '<button type="button" class="cvn-line-seg__btn cvn-line-seg__btn--change" data-cvn-dd-toggle aria-haspopup="true">Change size</button>'
                  + '<div class="cvn-line-dd__menu" hidden>' + items + '</div>'
                  + '</span>'
                  + '<button type="button" class="cvn-line-seg__btn' + (sel === 'gift' ? ' cvn-line-seg__btn--gift-on' : '') + '" data-cvn-sel="gift" data-cvn-sel-key="' + key + '">It\'s a gift</button>'
                  + '<button type="button" class="cvn-line-seg__btn' + (sel === 'keep' ? ' cvn-line-seg__btn--keep-on' : '') + '" data-cvn-sel="keep" data-cvn-sel-key="' + key + '">Keep as is</button>'
                  + '</div>';
                // ⚠ THE KEEP-THIS-SIZE CONSENT DOES NOT RIDE ON THE LINE ANY MORE.
                // It used to render under EVERY mis-sized row, so a cart with
                // four such items repeated the same refund sentence four times
                // and the cart read as a legal form. Consent belongs once, at
                // the moment it is actually given — which is the confirm dialog
                // on Checkout, under the list of the items it covers. It lives
                // in `cvn-size-confirm.liquid` now; do not restore it here.
                // The GIFT note stays: that one is per-line advice about that
                // specific piece, not a repeated agreement. "gift card" links
                // the gift card product when the snippet says it is live
                // (data-cvn-gift-url on the guard element) - plain text
                // otherwise, never a dead link.
                var note = '';
                if (sel === 'gift') {
                  var gEl = document.querySelector('cvn-size-guard[data-cvn-gift-url]');
                  var gUrl = gEl ? gEl.getAttribute('data-cvn-gift-url') : '';
                  // r17: the link carries THIS piece over as a pick, in the
                  // colour chosen here (?gift_picks=handle:variant — the gift
                  // page preloads it and turns gift mode on). Handle off the
                  // name link, variant off the line key; without either the
                  // plain page link stands.
                  if (gUrl) {
                    var gA = row.querySelector('.cart-item__name');
                    var gM = /\/products\/([a-z0-9-]+)/i.exec(gA ? (gA.getAttribute('href') || '') : '');
                    var gVid = String(key || '').split(':')[0];
                    if (gM && gVid) gUrl += (gUrl.indexOf('?') > -1 ? '&' : '?') + 'gift_picks=' + encodeURIComponent(gM[1] + ':' + gVid);
                  }
                  var gPhrase = gUrl
                    ? 'guarantee it with a <a class="cvn-line-gift__link" href="' + gUrl + '">gift card</a>'
                    : 'guarantee it with a gift card';
                  note = '<div class="cvn-line-gift">A gift? Make sure the piece suits them, or ' + gPhrase + ' so they pick exactly what they like. Every piece is made to order.</div>';
                }
                if (setInline('<span class="cvn-line-tag cvn-line-tag--warn">Not your recommended size</span>')) {
                  setSlot(seg + note);
                } else {
                  setSlot('<p class="cvn-line-warn">Not your recommended size</p>' + seg + note);
                }
              });
            };
            window.cvnDecorateLines = decorateLines;

            // ⚠ THE /cart PAGE'S OWN SECTIONS ARE REFRESHED TOO. A size swap
            // used to re-render only the drawer, so on /cart the page's row
            // sat on "Updating size…" forever — the page's cart machinery
            // knows nothing about this fetch. The page section ids come off
            // the elements' own data-id (they are template-scoped), and the
            // replacement targets each section's .js-contents, exactly as
            // Dawn's cart.js does.
            var refreshCartSurfaces = function () {
              var sects = ['cart-drawer', 'cart-icon-bubble'];
              var mci = document.getElementById('main-cart-items');
              var mcf = document.getElementById('main-cart-footer');
              if (mci && mci.dataset.id) sects.push(mci.dataset.id);
              if (mcf && mcf.dataset.id && sects.indexOf(mcf.dataset.id) === -1) sects.push(mcf.dataset.id);
              return fetch(window.location.pathname + '?sections=' + sects.join(','))
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  var parse = function (html, sel) {
                    var d = document.createElement('div');
                    d.innerHTML = html;
                    return d.querySelector(sel);
                  };
                  var freshInner = parse(sections['cart-drawer'] || '', '.drawer__inner');
                  var curInner = document.querySelector('#CartDrawer .drawer__inner');
                  if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
                  var curBubble = document.getElementById('cart-icon-bubble');
                  if (curBubble && sections['cart-icon-bubble']) {
                    var freshBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
                    if (freshBubble) curBubble.innerHTML = freshBubble.innerHTML;
                  }
                  [mci, mcf].forEach(function (host) {
                    if (!host || !host.dataset.id || !sections[host.dataset.id]) return;
                    var freshC = parse(sections[host.dataset.id], '.js-contents');
                    var curC = host.querySelector('.js-contents');
                    if (freshC && curC) curC.innerHTML = freshC.innerHTML;
                  });
                  decorateLines();
                  if (window.cvnPrepPageRails) { try { window.cvnPrepPageRails(); } catch (e) {} }
                });
            };

            // "What's my size?" / "Find my size": open the finder in place.
            // Delegated so every [data-cvn-guard-sf] pill works, including
            // ones re-rendered with the cart. When this page has no finder,
            // fetch the cvn-sf-host section, inject it into a zero-size mount
            // (FAQ host pattern) and open it - the shopper never leaves the
            // page. Buttons, not anchors: the theme's client-side nav
            // captures anchor clicks before handlers.
            var openSfInPlace = function () {
              // only triggers OUTSIDE the quick-view dialog count: the
              // dialog's embedded finder instance is stripped (single-instance
              // rule), so its pill is a label the fallback answers for
              var trigger = null;
              document.querySelectorAll('[data-cvn-sf-open]').forEach(function (t) {
                if (!trigger && !t.closest('quick-add-modal')) trigger = t;
              });
              if (!trigger) return false;
              // the cart drawer stays OPEN (Zeus): the finder overlay portals
              // to <body> at z 1300, above the drawer (1000) and the quick
              // view (1200), so it reads as a layer over the cart
              trigger.click();
              return true;
            };
            var sfOverlayOpen = function () {
              return [].some.call(document.querySelectorAll('.cvn-sf__overlay'), function (o) { return !o.hidden; });
            };
            // fetch the cvn-sf-host section, mount it, re-create its scripts
            // (innerHTML scripts never execute) and open the fresh finder
            var cvnSfMounting = false;
            var cvnSfFetchOpen = function () {
              if (cvnSfMounting) return;
              // ONE mounted instance, ever: a failed attempt must not leave a
              // corpse for the next attempt (or for cvn-sf-marks) to bind
              if (window.cvnSfMountEl) {
                // a mount already exists - its trigger just needs the click
                var mt = window.cvnSfMountEl.querySelector('[data-cvn-sf-open]');
                if (mt) { mt.click(); return; }
                window.cvnSfMountEl.remove();
                window.cvnSfMountEl = null;
              }
              cvnSfMounting = true;
              fetch('/?section_id=cvn-sf-host')
                .then(function (response) {
                  if (!response.ok) throw new Error(response.status);
                  return response.text();
                })
                .then(function (html) {
                  var mount = document.createElement('div');
                  mount.style.cssText = 'position:absolute;width:0;height:0;overflow:visible';
                  mount.innerHTML = html;
                  document.body.appendChild(mount);
                  window.cvnSfMountEl = mount;
                  mount.querySelectorAll('script').forEach(function (old) {
                    if ((old.type || '').indexOf('json') > -1) return;
                    var fresh = document.createElement('script');
                    if (old.src) { fresh.src = old.src; fresh.async = false; }
                    else { fresh.textContent = old.textContent; }
                    old.replaceWith(fresh);
                  });
                  cvnSfMounting = false;
                  // rebind cvn-sf-marks to the fresh instance via its PRIVATE
                  // hook (never cvn:navigated - the theme's nav system listens
                  // to that too and a synthetic dispatch fires its swap
                  // machinery with no destination)
                  document.dispatchEvent(new Event('cvn:sf-rebind'));
                  if (!openSfInPlace()) window.location.href = '/pages/our-pieces?cvn_sf_open=1';
                })
                .catch(function () {
                  cvnSfMounting = false;
                  window.location.href = '/pages/our-pieces?cvn_sf_open=1';
                });
            };
            // every open attempt is VERIFIED: if no overlay is visible shortly
            // after the click, the trigger's listener was dead (a content swap
            // replaced it) - mount a fresh finder instead of doing nothing
            var openSfVerified = function () {
              if (!openSfInPlace()) { cvnSfFetchOpen(); return; }
              setTimeout(function () {
                if (!sfOverlayOpen()) cvnSfFetchOpen();
              }, 250);
            };
            // rail bookmark: toggles the recommendations panel; the drawer
            // reopening always reopens the rail (the class observer below)
            document.addEventListener('click', function (event) {
              if (!event.target.closest) return;
              var tgl = event.target.closest('[data-cvn-rail-toggle]');
              if (!tgl) return;
              event.preventDefault();
              var rail = tgl.closest('[data-cvn-rail]');
              if (rail) rail.classList.toggle('cvn-rail--closed');
            });
            var cvnDrawerEl = document.querySelector('cart-drawer');
            if (cvnDrawerEl) {
              new MutationObserver(function () {
                if (cvnDrawerEl.classList.contains('active') || cvnDrawerEl.classList.contains('animate')) {
                  var r = document.querySelector('[data-cvn-rail]');
                  if (r) r.classList.remove('cvn-rail--closed');
                  // cards only build while visible: poke the grid-card script
                  // on every open (covers the add-to-cart auto-open, which
                  // clicks nothing and so triggers none of the other hooks)
                  railBoot();
                }
              }).observe(cvnDrawerEl, { attributes: true, attributeFilter: ['class'] });
            }
            document.addEventListener('click', function (event) {
              if (!event.target.closest) return;
              // a rail Quick view click: remember the card's product type so
              // the dialog's view-details label can name the blank
              var qvb = event.target.closest('.cvn-rail-qv');
              if (qvb) {
                var qvcw = qvb.closest('.card-wrapper');
                // ⚠ BY ID, NOT "the first parked modal". `#QuickAddCvn` survives
                // on <body> now, and a re-rendered `#QuickAddRail` is appended
                // AFTER it — so a positional query hands the RAIL card's product
                // type to the COLLECTION dialog and the rail's own label loses
                // its blank. The two ids are mutually exclusive by construction
                // (cart-drawer.liquid emits one, cvn-rail-block the other).
                var qvm = document.getElementById('QuickAddRail');
                // ⚠ `data-ptype` — the BROWSE word ("T-Shirt"), and that is
                // deliberate even though every LABEL uses the display word.
                // This line is not naming the product: the dialog's heading
                // directly above it already carries the full title, so what is
                // left for this sentence to say is what KIND of thing it is —
                // a category statement, which is the browse vocabulary's job.
                // "View Full Details of this Tee" repeats the word the heading
                // just used; "…of this T-Shirt" adds the piece's category.
                if (qvm) qvm.dataset.cvnPtype = (qvcw && qvcw.dataset.ptype) || '';
              }
              // View full details navigates via the theme's client-side nav,
              // which swaps #MainContent but leaves the body-parked dialog and
              // the drawer standing over the new page - close both first
              var vd = event.target.closest('quick-add-modal.cvn-rail-modal .product__view-details');
              if (vd) {
                var qm = vd.closest('quick-add-modal');
                if (qm && typeof qm.hide === 'function') qm.hide();
                var dcl = document.querySelector('cart-drawer');
                if (dcl && typeof dcl.close === 'function') dcl.close();
              }
              var sfp = event.target.closest('[data-cvn-guard-sf]');
              if (sfp && !sfp.disabled) {
                openSfVerified();
                return;
              }
              // the quick-view dialog's OWN finder pill: its listener dies
              // when Dawn swaps the content - let its own handler try, then
              // verify an overlay actually opened and fall back if not
              // trusted clicks only: openSfInPlace fires synthetic clicks on
              // these same pills, and reacting to our own click loops the
              // verify chain into repeated mounts
              var sfq = event.isTrusted && event.target.closest('quick-add-modal.cvn-rail-modal [data-cvn-sf-open]');
              if (sfq) {
                setTimeout(function () {
                  if (!sfOverlayOpen()) openSfVerified();
                }, 250);
              }
              var ddt = event.target.closest('[data-cvn-dd-toggle]');
              if (ddt) {
                var menu = ddt.parentNode.querySelector('.cvn-line-dd__menu');
                var wasHidden = menu ? menu.hidden : true;
                document.querySelectorAll('.cvn-line-dd__menu').forEach(function (m) { m.hidden = true; });
                if (menu) menu.hidden = !wasHidden;
                return;
              }
              if (!event.target.closest('.cvn-line-dd')) {
                document.querySelectorAll('.cvn-line-dd__menu').forEach(function (m) { m.hidden = true; });
              }
              var selBtn = event.target.closest('[data-cvn-sel]');
              if (selBtn) {
                try { sessionStorage.setItem('cvn_sel_' + selBtn.getAttribute('data-cvn-sel-key'), selBtn.getAttribute('data-cvn-sel')); } catch (e) {}
                decorateLines();
                return;
              }
              var swap = event.target.closest('[data-cvn-swap]');
              if (swap && !swap.disabled) {
                swap.disabled = true;
                var vid = parseInt(swap.getAttribute('data-cvn-swap'), 10);
                var key = swap.getAttribute('data-cvn-swap-key');
                var qty = parseInt(swap.getAttribute('data-cvn-swap-qty') || '1', 10);
                // the refreshed cart re-adds this line at the top; remember the
                // from/to variant ids so applyCartOrder can keep its position
                window.cvnPendingSwap = { from: String(key).split(':')[0], to: String(vid) };
                // immediate feedback: close the menu and turn the size row
                // into a spinner until the refreshed cart lands
                var ddm = swap.closest('.cvn-line-dd__menu');
                if (ddm) ddm.hidden = true;
                var rowEl = swap.closest('[data-cvn-cid]');
                if (rowEl) {
                  var optEl = rowEl.querySelector('[data-cvn-size-opt]');
                  if (optEl) optEl.innerHTML = '<span class="cvn-line-spin" aria-hidden="true"></span><span class="cvn-line-loading">Updating size&hellip;</span>';
                  var slotEl = rowEl.querySelector('[data-cvn-line-slot]');
                  if (slotEl) { slotEl.hidden = true; slotEl.innerHTML = ''; }
                }
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: key, quantity: 0 })
                })
                  .then(function (r) {
                    if (!r.ok) throw new Error('change failed');
                    return fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: vid, quantity: qty })
                    });
                  })
                  .then(function (r) {
                    if (!r.ok) throw new Error('add failed');
                    return refreshCartSurfaces();
                  })
                  .catch(function () { refreshCartSurfaces(); });
              }
            });

            var recheckLive = function () {
              document.querySelectorAll('cvn-size-guard').forEach(function (g) {
                if (g._recheck) g._recheck();
              });
              decorateLines();
            };
            // profile changes land when the finder closes, or from other tabs;
            // opening the cart is also a natural moment to re-evaluate
            document.addEventListener('click', function (event) {
              if (!event.target.closest) return;
              if (event.target.closest('[data-cvn-sf-close], [data-cvn-sf-overlay]')) {
                setTimeout(recheckLive, 80);
              }
              if (event.target.closest('#cart-icon-bubble, .header__icon--cart')) {
                setTimeout(recheckLive, 250);
              }
            }, true);
            window.addEventListener('focus', recheckLive);
            window.addEventListener('pageshow', recheckLive);
            document.addEventListener('visibilitychange', function () {
              if (!document.hidden) recheckLive();
            });
            window.addEventListener('storage', recheckLive);
            // same-tab profile changes: the finder broadcasts on every save
            // and forget, so the drawer rows, header pill and dialog label
            // refresh live (the storage event only fires cross-tab)
            document.addEventListener('cvn:sf-profile', function () { decorateLines(); });
            // The theme re-renders cart rows in place on every quantity or
            // line change, wiping the decorations; watch the cart containers
            // and re-decorate. Own writes are filtered out so this can't loop.
            var cvnDecoTimer = null;
            var cvnMo = new MutationObserver(function (muts) {
              var relevant = false;
              for (var i = 0; i < muts.length; i++) {
                var t = muts[i].target;
                if (t && t.closest && t.closest('[data-cvn-line-slot], [data-cvn-size-opt], [data-cvn-sf-entry], .cvn-size-guard, .cvn-line-dd__menu, .cart__checkout-button, .cvn-rail')) continue;
                relevant = true;
                break;
              }
              if (!relevant) return;
              if (cvnDecoTimer) clearTimeout(cvnDecoTimer);
              cvnDecoTimer = setTimeout(function () {
                cvnDecoTimer = null;
                recheckLive();
              }, 60);
            });
            [document.querySelector('cart-drawer'), document.getElementById('main-cart-items')].forEach(function (n) {
              if (n) cvnMo.observe(n, { childList: true, subtree: true });
            });
            document.addEventListener('click', function (event) {
              var btn = event.target.closest ? event.target.closest('[data-cvn-locked]') : null;
              if (!btn) return;
              event.preventDefault();
              event.stopPropagation();
              // ⚠ THE GUARD ON THE SAME SURFACE AS THE BUTTON, NOT THE FIRST ONE
              // IN THE DOCUMENT. This was `querySelector('cvn-size-guard:not([hidden])')`
              // — singular — and on /cart there are TWO visible guards: the
              // drawer's (rendered by the LAYOUT, so always first) and the page's.
              // Clicking the PAGE's locked Checkout therefore scrolled to and
              // rang the DRAWER's guard, inside a closed panel: no scroll, no
              // ring, nothing on screen at all, while the drawer did it
              // perfectly. Exactly the singular-query trap already written up
              // for applyCartOrder/railBoot/refreshCartSurfaces — a singular
              // query always resolves to the layout's copy.
              var inDrawer = !!btn.closest('cart-drawer');
              var guard = null;
              document.querySelectorAll('cvn-size-guard:not([hidden])').forEach(function (g) {
                if (guard) return;
                if (!!g.closest('cart-drawer') === inDrawer) guard = g;
              });
              // a surface with no guard of its own falls back to any visible one
              // rather than doing nothing
              if (!guard) guard = document.querySelector('cvn-size-guard:not([hidden])');
              if (!guard) return;
              guard.scrollIntoView({ behavior: 'smooth', block: 'center' });
              var row = guard.querySelector('.cvn-size-guard__ack');
              if (row) {
                row.classList.remove('cvn-size-guard__ack--nudge');
                void row.offsetWidth;
                row.classList.add('cvn-size-guard__ack--nudge');
              }
            }, true);
            // ⚠ AND BOOT THE RAILS ONCE, HERE. On a cart WITH lines the box
            // path below reaches railBoot() through decorateLines(); on an
            // EMPTY cart there is no box path, and the drawer-open hook only
            // fires when the drawer opens — so the /cart page's own empty-state
            // rail would carry a dialog nobody ever parked. The rails are
            // already in the document by DOMContentLoaded, and railBoot is
            // idempotent, so calling it here costs nothing on any other path.
            railBoot();
          }
          var box = this.querySelector('.cvn-size-guard__box');
          if (!box) return;
          var acked = false;
          try { acked = sessionStorage.getItem('cvn_size_ack') === '1'; } catch (e) {}
          box.checked = acked;
          var unlockAll = function () {
            document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function (btn) {
              btn.classList.remove('cvn-checkout-locked');
              btn.removeAttribute('data-cvn-locked');
              btn.removeAttribute('aria-disabled');
            });
          };
          var apply = function () {
            var ok = box.checked;
            try { sessionStorage.setItem('cvn_size_ack', ok ? '1' : '0'); } catch (e) {}
            document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function (btn) {
              btn.classList.toggle('cvn-checkout-locked', !ok);
              if (ok) {
                btn.removeAttribute('data-cvn-locked');
                btn.removeAttribute('aria-disabled');
              } else {
                btn.setAttribute('data-cvn-locked', '1');
                btn.setAttribute('aria-disabled', 'true');
                if (!btn.querySelector('.cvn-co-tip')) {
                  var tip = document.createElement('span');
                  tip.className = 'cvn-co-tip';
                  tip.textContent = 'Confirm your sizes first, one tick above';
                  btn.appendChild(tip);
                }
              }
            });
          };
          // Live re-evaluation: measured state can change mid-session (the
          // quiz saves a profile, or "Forget my sizes" clears one) with no
          // drawer re-render, so the guard toggles rather than deciding once.
          var self = this;
          var recheck = function () {
            var measured = false;
            try { measured = !!localStorage.getItem('cvn_fit_profile'); } catch (e) {}
            self.hidden = measured;
            if (measured) unlockAll();
            else apply();
          };
          this._apply = apply;
          this._recheck = recheck;
          box.addEventListener('change', function (event) {
            event.stopPropagation();
            apply();
          });
          // checkout buttons sit elsewhere in the document; wait a frame
          requestAnimationFrame(function () {
            recheck();
            if (window.cvnDecorateLines) window.cvnDecorateLines();
          });
        }
        disconnectedCallback() {
          document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function (btn) {
            btn.classList.remove('cvn-checkout-locked');
            btn.removeAttribute('data-cvn-locked');
            btn.removeAttribute('aria-disabled');
          });
        }
      });
    }
  
